/**
 * app类型 (app列表中的类型)
 */
enum AppType {

    /** 三条腿应用 */
    legged3 = 0,

    /** 两条腿应用 */
    legged2 = 1,

    /** 系统应用 */
    system  = 2,
}

export default AppType;


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/entry/constant/AppType/index.ts